webpackJsonp([18],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Styles
__webpack_require__(214);

// JavaScript
var $ = __webpack_require__(0);
var $body = $('body');
var displayAttributeValue = $body.attr("data-environment-display");
var shouldDisplayWarning = displayAttributeValue == "true" || displayAttributeValue == "True";

if (shouldDisplayWarning) {
    var environment = $body.attr("data-environment");
    __webpack_require__.e/* require.ensure */(1).then((function () {
        var Warning = __webpack_require__(6);
        new Warning(environment);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[213]);


// WEBPACK FOOTER //
// com-environment-warn.js